<div class="whats-new-step" [attr.data-testid]="'whats-new-step-' + step().id">
  <div class="illustration">
    <img class="illustration-image" [src]="step().image" alt="" role="presentation" />
  </div>

  <div class="content">
    <h2 class="title">{{ step().titleKey | transloco }}</h2>
    <!-- Progress indicator -->
    <ng-content></ng-content>
    <p class="description">{{ step().descriptionKey | transloco }}</p>
  </div>
</div>
